import {
    FETCH_BUDGET,
    UPDATE_BUDGET,
    VALIDATE_CHECKOUT,
    VALIDATE_WORKWEAR_USER,
    GET_WORKEAR_MENU_LINK
} from '../constants';
import { ViewMode } from '../constants';
import { error as errorReducer } from './Error.reducer';

const defaultState = {
    validateWorkWear:{
        IsWorkWearCustomer:false, 
    },
    budget: {
        budget: 0,
        budgetRemaining: 0,
        excludedFromBudget: false,
    },
    validateCheckout: {
        hasSufficientBudget: false,
        errorMessage: "",
    },
    getWorkWearLink:{
        linkText: "",
        linkTextUrl: "",
    }
}

export const workWearReducer = (state = defaultState, action) => {
    const {type, payload} = action;
    switch(type) {
        case FETCH_BUDGET:
        case UPDATE_BUDGET:
        case VALIDATE_WORKWEAR_USER:
        case VALIDATE_CHECKOUT:
        case GET_WORKEAR_MENU_LINK:
            return {
                ...state,
                // errors: {},
                ...payload,
            };
        default:
            return state;
    }
}